import { Field, FieldWrapper } from '@progress/kendo-react-form';
import React, { useState } from 'react';
 
import { CusFormComboBox } from '../validation/Form-Components';
import appDetailsData from '../data/applicantdetailsdata.json'
import {reqDDLValidator } from '../validation/Validators'
import occupations from '../data/industrylist.json';
import AddRemoveBtn from './AddRemoveBtn';
import helper from '../factory/Helper.js';
import { filterBy } from "@progress/kendo-data-query";
 
 
const ApplicantDtlsOccupation = (props) => {

    const{fProps, array, disabled} = props;
 
    const [showDescActOcc2,setShowDescActOcc2] = useState(array? array[1]? true:false:false);
    const [showDescActOcc3,setShowDescActOcc3] = useState(array? array[2]? true:false:false);
    const [selectedOccup1,setSelectedOccup1] = useState(array? helper.getObjInArray(array[0],occupations):{});
    const [selectedOccup2,setSelectedOccup2] = useState(array? helper.getObjInArray(array[1],occupations):{});

    const [data, setData] = React.useState(occupations.slice());

    const filterData = (filter) => {
      const data = occupations.slice();
      return filterBy(data, filter);
    };
  
    const filterChange = (event) => {
      setData(filterData(event.filter));
    };

    const handleOnClick1 = (status) => {
      if(status === 'Add') {
        if(fProps.valueGetter("DescActOcc1"+props.seq)) {
          setShowDescActOcc2(true);
        }
      }
      else {  //Remove
        setShowDescActOcc2(false);
        fProps.onChange('DescActOcc2'+props.seq,'');
      }
    }

    const handleOnClick2 = (status) => {
      if(status === 'Add') {
        if(fProps.valueGetter("DescActOcc2"+props.seq)) {
          setShowDescActOcc3(true);
        }
      }
      else {  //Remove
        setShowDescActOcc3(false);
        fProps.onChange('DescActOcc3'+props.seq,'');
      }
    }
    
    return (
        <div>
          <FieldWrapper>
          <Field leftLabelId={'lblDescActOcc1'} leftLabelName={appDetailsData.formSubTitle.ST6}
            id={'DescActOcc1'+props.seq} name={'DescActOcc1'+props.seq}
            component={CusFormComboBox}
            textField={'label'}
            data={data}
            filterable={true}
            onFilterChange={filterChange}
            dataItemKey={'value'}
            placeholder={'Please select'} 
            disabled={disabled}
            validator={reqDDLValidator}
            onChange={(e)=> {
              if(e.value === null){
                return;
              }
              setSelectedOccup1(e.value);
              
            }} />
             
            </FieldWrapper>

          {!showDescActOcc3 && <AddRemoveBtn defBtnValue={!showDescActOcc2} seq={1} label={appDetailsData.label.addIndustry} disabled={disabled} onClick={handleOnClick1} />}

          {showDescActOcc2&& 
          <Field leftLabelId={'lblDescActOcc2'} leftLabelName={appDetailsData.formSubTitle.ST6}
            id={'DescActOcc2'+props.seq} name={'DescActOcc2'+props.seq}
            component={CusFormComboBox}
            textField={'label'}
            data={helper.filterArrayByValue(data,selectedOccup1.value)}
            filterable={true}
            onFilterChange={filterChange}
            dataItemKey={'value'}
            placeholder={'Please select'} 
            disabled={disabled}
            validator={reqDDLValidator} 
            onChange={(e)=>{
              if(e.value === null){
                return;
              }
              setSelectedOccup2(e.value);
            }} />}

          {showDescActOcc2&&<AddRemoveBtn defBtnValue={!showDescActOcc3} seq={2} label={appDetailsData.label.addIndustry} disabled={disabled} onClick={handleOnClick2} />}

          {showDescActOcc3&& <Field leftLabelId={'lblDescActOcc3'} leftLabelName={appDetailsData.formSubTitle.ST6}
            id={'DescActOcc3'+props.seq} name={'DescActOcc3'+props.seq}
            component={CusFormComboBox}
            textField={'label'}
            data={helper.filterArrayByValue(helper.filterArrayByValue(data,selectedOccup1.value),selectedOccup2.value)}
            filterable={true}
            onFilterChange={filterChange}
            dataItemKey={'value'}
            placeholder={'Please select'} 
            validator={reqDDLValidator} 
            disabled={disabled}
            onChange={(e)=>{
              if(e.value === null){
                return;
              }
            
            }}
            />}

        </div>
    )
}

export default ApplicantDtlsOccupation

